import dayjs from "dayjs";

/**
 * Checks if the minimum lead time requirement is met
 * @param minimumLeadTimeInMinutes - The minimum lead time required in minutes
 * @param scheduledTime - Optional scheduled time object with day and time
 * @returns true if the time difference is less than the minimum lead time (warning needed), false if no scheduled time
 */
export const isUnderMinimumLeadTime = (
  minimumLeadTimeInMinutes: number,
  scheduledTime?: { day: string; time: string },
): boolean => {
  const now = dayjs();

  const targetTime = scheduledTime
    ? dayjs(`${scheduledTime.day}T${scheduledTime.time}`)
    : now;

  if (!targetTime.isValid()) throw new Error("Invalid scheduled time");

  const differenceInMinutes = targetTime.diff(now, "minute");

  return differenceInMinutes < minimumLeadTimeInMinutes;
};

/**
 * Derives the ISO 8601 "available at" datetime from the basket's scheduled time.
 * This is the fulfillment time sent to the menu endpoints so availability is
 * evaluated against the customer's selected slot.
 * @param scheduledTime - Optional scheduled time object with day and time
 * @returns ISO 8601 datetime string, or undefined when there is no (valid)
 * scheduled time — menus are then evaluated against "now" (unchanged behavior).
 */
export const getAvailableAt = (scheduledTime?: {
  day: string;
  time: string;
}): string | undefined => {
  if (!scheduledTime) return undefined;

  const availableAt = dayjs(`${scheduledTime.day}T${scheduledTime.time}:00`);

  return availableAt.isValid() ? availableAt.toISOString() : undefined;
};
